<template>
  <div class="contest-detail">
    <div class="detail-poster">
      <img :src="detail.poster" />
    </div>
    
    <div :class="['content',{'not-full':true}]">
      <!--  match_introduction / 大赛简介,design_introduction / 设计说明 ,about_organizer / 关于主办方,match_instructions / 参赛须知,match_information / 参赛资料 -->
      <div class="all-content">
        <div v-html="detail.content"></div>
      </div>
    </div>
    
    <SideMenu :mainClass="sideMenuClass" :shareUrl="shareUrl"></SideMenu>
  </div>
</template>
<script>
import { getCaseDetail } from "@/api/index";
import SideMenu from '@/components/SideMenu/SideMenu'
import {
  addUserContribution
} from "@/api/index"
import {mapState} from 'vuex';
export default {
  components: {
    SideMenu
  },
  data() {
    return {
      posts_list: [],
      detail: {},
      show_sign_in: false,
      show_upload: false,
      form: {
        title: "",
        image_list: [],
        content: "",
        is_agree:false,
        custom_field:[]
      },
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      case_id:'',
      show_detail:false,
      post_uuid:'',
      is_signin:'',
      observer: null,
      isScrolling: false,
      scrollTimer: null,
      timeInterval:null,
      readTime:0
      
    };
  },
  computed:{
     ...mapState(['taskSetting','userInfo']),
    is_login(){
      return this.$store.state.is_login;
    },
    
    sideMenuClass(){
      return `position: fixed;
              bottom: 100px;
              right: 0px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;`
    },
    shareUrl() {
      let url = `${window.location.origin}/CaseDetail/CaseDetail/${this.case_id}`;
      return url
    },
    
    
  },
  
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "light");
    });
  },
  mounted() {
    let { case_id } = this.$route.params;
    
    if (!case_id) {
      console.log("case id is null");
      history.back();
      return;
    }
    
    this.case_id = case_id;
    this.onGetDetail();
    
  },
  beforeDestroy() {
    
  },
  watch: {
      
  },
  methods: {    
    async onGetDetail() {
      try {
        const { data } = await getCaseDetail({ case_id: this.case_id });
        console.log("data----", data);
        this.detail = data;
      } catch (e) {
        console.log("eee-", e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./CasesDetail.scss";
</style>
